import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBWXB_DOaL0hrQlU2xLJ_ZWzCqn613X1pk",
  authDomain: "vizioncrypto-379118.firebaseapp.com",
  projectId: "vizioncrypto-379118",
  storageBucket: "vizioncrypto-379118.appspot.com",
  messagingSenderId: "565522373775",
  appId: "1:565522373775:web:5f30544c3f5b005d2f24fa",
  measurementId: "G-040QTEYW2G",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const db = getFirestore(app);
const storage = getStorage(app);

const auth = getAuth(app);

export { auth, db, storage };

export const getTokenFirebase = (setTokenFound) => {
  return getToken(messaging, {
    vapidKey:
      "BKkWqdzlFUIa8SOjqTtqBY6E0AkGqt4p16h5fSc5f7Z-akotsLrHWbNW_Wnz-SBhbOQ1kmptM1RPozI1WtMGQlE",
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        setTokenFound(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        setTokenFound('');
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});